module.exports = __webpack_public_path__ + "static/img/donie.6701a43.svg";


//////////////////
// WEBPACK FOOTER
// ./static/donie.svg
// module id = R35I
// module chunks = 0